module.exports = {
        srcSet: __webpack_public_path__ + "cf5f6b60dd85eb9b-600.png"+" 600w"+","+__webpack_public_path__ + "9c9a0a547c5854b7-1000.png"+" 1000w",
        images: [{path: __webpack_public_path__ + "cf5f6b60dd85eb9b-600.png",width: 600,height: 338},{path: __webpack_public_path__ + "9c9a0a547c5854b7-1000.png",width: 1000,height: 563}],
        src: __webpack_public_path__ + "9c9a0a547c5854b7-1000.png",
        toString: function(){return __webpack_public_path__ + "9c9a0a547c5854b7-1000.png"},
        
        width: 1000,
        height: 563
      }